/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Pairing_UnpairedInputs */

const cs_ebr_pairing_unpaired = /** @type {(inputs: Ebr_Pairing_UnpairedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nespárovaní`)
};

const en_ebr_pairing_unpaired = /** @type {(inputs: Ebr_Pairing_UnpairedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unpaired`)
};

/**
* | output |
* | --- |
* | "unpaired" |
*
* @param {Ebr_Pairing_UnpairedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_pairing_unpaired = /** @type {((inputs?: Ebr_Pairing_UnpairedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Pairing_UnpairedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_pairing_unpaired(inputs)
	return cs_ebr_pairing_unpaired(inputs)
});